/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SubscriberInfo {
  addressIdActiveOnPerson?: number;
  addressIdActiveOnSubscriber?: number;
  billingIsShipping?: boolean;
  boxId?: string;
  dateCreated?: Date;
  dateUpdated?: Date;
  endEdition?: number;
  lastEdition?: number;
  nextCycleDate?: Date;
  nextEdition?: number;
  paymentMethod?: SubscriberInfo.PaymentMethodEnum;
  personId?: number;
  remainingEditions?: number;
  shippingCity?: string;
  shippingCityCode?: number;
  shippingCountry?: string;
  shippingCountryCode?: number;
  shippingName?: string;
  shippingNeighborhood?: string;
  shippingPhone?: string;
  shippingPostalCode?: string;
  shippingPrice?: number;
  shippingState?: string;
  shippingStateCode?: number;
  shippingStreet?: string;
  shippingStreetExtensions?: string;
  shippingStreetNumber?: string;
  startEdition?: number;
  status?: string;
  subscriberId?: number;
  subscriberStatus?: number;
  subscriptionId?: number;
  subscriptionName?: string;
  subscriptionPrice?: number;
  subscriptionTypeId?: number;
  subscriptionTypeInstallments?: number;
  subscriptionTypeName?: string;
}
export namespace SubscriberInfo {
  export type PaymentMethodEnum = 'CREDIT_CARD' | 'PIX';
  export const PaymentMethodEnum = {
    CREDITCARD: 'CREDIT_CARD' as PaymentMethodEnum,
    PIX: 'PIX' as PaymentMethodEnum
  };
}
